module.exports = __webpack_public_path__ + "bf2.no2.2f8d4831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bf2.no2.jpg
// module id = /zLR
// module chunks = 0